import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository, ITokenService, IStorageService } from '../../../domain/ports';
import type { DeleteAccountData, DeleteAccountResult } from '../../dto/dtos';

export class DeleteAccountUseCase implements IUseCase<DeleteAccountData, DeleteAccountResult> {
  constructor(
    private readonly authRepository: IAuthRepository,
    private readonly tokenService: ITokenService,
    private readonly storageService: IStorageService,
  ) {}

  async execute(input: DeleteAccountData): Promise<DeleteAccountResult> {
    const response = await this.authRepository.deleteAccount(input);

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Echec de la suppression du compte');
    }

    this.tokenService.clearTokens();
    this.storageService.clearAll();

    return response.data;
  }
}
